module["exports"] = [
  "#####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/address/postcode.js
// module id = 1122
// module chunks = 0